import gql from 'graphql-tag';

export default gql`
    mutation RevertStageSheet($input: RevertStageSheetInput) {
        revertStageSheet(input: $input) {
            errors
        }
    }
`;
